import { GeneralSettingsModel } from './models/account/generalSettingsModel';
import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router';
import { AppConfig } from './core';
import { AccountService } from '../app/core/services/account.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { getClientFromUrl, UNKNOWN_CLIENT_MESSAGE } from './core/helpers/utils';
import { MiniProfilerService } from './core/services/mini-profiler.service';
import { environment } from '../environments/environment';
declare let ga: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {
  title = 'app';
  unknownClientMessage: string = null;

  generalSettings(): GeneralSettingsModel {
    return this.accountService ? this.accountService.generalSettings : null;
  }
  public constructor(
    private accountService: AccountService,
    private titleService: Title,
    private router: Router,
    private http: HttpClient,
    private profiler: MiniProfilerService,
  ) {
    ga('create', AppConfig.settings.googleUAID, 'auto');
    const clientFromUrl = getClientFromUrl();
    ga('set', 'app_name', 'Client Portal');
    ga('set', 'client', clientFromUrl);
    ga('set', 'page_type', 'Angular');
    if (!clientFromUrl) {
      this.unknownClientMessage = UNKNOWN_CLIENT_MESSAGE;
    } else {
      this.accountService.getGeneralSettings().subscribe(x => {
        this.titleService.setTitle(this.accountService.generalSettings.businessFullName);
      }, error => {
        // show the server message, for example when the company does not exist or is not active
        if (typeof error === 'string') {
          this.unknownClientMessage = error;
        }
      });
    }



    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        let urlTree = this.router.parseUrl(event.urlAfterRedirects);
        let parameters = JSON.stringify(urlTree.queryParams);
        urlTree.queryParams = {};
        urlTree.fragment = null;
        let cleanUrl = urlTree.toString();

        this.accountService.logNavigation(cleanUrl, parameters)
          .pipe()
          .subscribe(
            data => { },
            error => { });

        ga('set', 'page', cleanUrl);
        ga('set', 'location', window.location.origin + cleanUrl);
        ga('send', 'pageview');
        (window as any).NavigationRouterState = 'NavigationEnd: ' + cleanUrl;
      } else if (event instanceof NavigationStart) {
        (window as any).NavigationRouterState = 'NavigationStart';
        if (!environment.production) {
          this.profiler.clear();
        }
      }
      else if (event instanceof NavigationCancel) {
        (window as any).NavigationRouterState = 'NavigationCancel';
      }
      else if (event instanceof NavigationError) {
        (window as any).NavigationRouterState = 'NavigationError';
      }
      console.debug((window as any).NavigationRouterState);
    });
  }

  ngOnInit() {
    if (!environment.production)
      this.profiler.init();
  }

  @HostListener("window:message", ["$event"])
  OnWindoMessage( $event: MessageEvent) {
    
    console.log(`Received message: ${$event.data} from ${$event.origin}`);
    
    if ($event.origin.indexOf("optomiser.com") == -1
      && $event.origin.indexOf("optomiser-development.com") == -1)
    //  return;

    if (!$event.data)
        return;
    try {
      
      var message = JSON.parse($event.data);
     

    } catch (ex) {

    }
  }
}
